/** @license React v0.13.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var c = null,
    f = !1,
    h = 3,
    k = -1,
    l = -1,
    m = !1,
    n = !1;

function p() {
  if (!m) {
    var a = c.expirationTime;
    n ? q() : n = !0;

    _r(t, a);
  }
}

function u() {
  var a = c,
      b = c.next;
  if (c === b) c = null;else {
    var d = c.previous;
    c = d.next = b;
    b.previous = d;
  }
  a.next = a.previous = null;
  d = a.callback;
  b = a.expirationTime;
  a = a.priorityLevel;
  var e = h,
      Q = l;
  h = a;
  l = b;

  try {
    var g = d();
  } finally {
    h = e, l = Q;
  }

  if ("function" === typeof g) if (g = {
    callback: g,
    priorityLevel: a,
    expirationTime: b,
    next: null,
    previous: null
  }, null === c) c = g.next = g.previous = g;else {
    d = null;
    a = c;

    do {
      if (a.expirationTime >= b) {
        d = a;
        break;
      }

      a = a.next;
    } while (a !== c);

    null === d ? d = c : d === c && (c = g, p());
    b = d.previous;
    b.next = d.previous = g;
    g.next = d;
    g.previous = b;
  }
}

function v() {
  if (-1 === k && null !== c && 1 === c.priorityLevel) {
    m = !0;

    try {
      do {
        u();
      } while (null !== c && 1 === c.priorityLevel);
    } finally {
      m = !1, null !== c ? p() : n = !1;
    }
  }
}

function t(a) {
  m = !0;
  var b = f;
  f = a;

  try {
    if (a) for (; null !== c;) {
      var d = exports.unstable_now();

      if (c.expirationTime <= d) {
        do {
          u();
        } while (null !== c && c.expirationTime <= d);
      } else break;
    } else if (null !== c) {
      do {
        u();
      } while (null !== c && !w());
    }
  } finally {
    m = !1, f = b, null !== c ? p() : n = !1, v();
  }
}

var x = Date,
    y = "function" === typeof setTimeout ? setTimeout : void 0,
    z = "function" === typeof clearTimeout ? clearTimeout : void 0,
    A = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0,
    B = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0,
    C,
    D;

function E(a) {
  C = A(function (b) {
    z(D);
    a(b);
  });
  D = y(function () {
    B(C);
    a(exports.unstable_now());
  }, 100);
}

if ("object" === typeof performance && "function" === typeof performance.now) {
  var F = performance;

  exports.unstable_now = function () {
    return F.now();
  };
} else exports.unstable_now = function () {
  return x.now();
};

var _r,
    q,
    w,
    G = null;

"undefined" !== typeof window ? G = window : "undefined" !== typeof global && (G = global);

if (G && G._schedMock) {
  var H = G._schedMock;
  _r = H[0];
  q = H[1];
  w = H[2];
  exports.unstable_now = H[3];
} else if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
  var I = null,
      J = function J(a) {
    if (null !== I) try {
      I(a);
    } finally {
      I = null;
    }
  };

  _r = function r(a) {
    null !== I ? setTimeout(_r, 0, a) : (I = a, setTimeout(J, 0, !1));
  };

  q = function q() {
    I = null;
  };

  w = function w() {
    return !1;
  };
} else {
  "undefined" !== typeof console && ("function" !== typeof A && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof B && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
  var K = null,
      L = !1,
      M = -1,
      N = !1,
      O = !1,
      P = 0,
      R = 33,
      S = 33;

  w = function w() {
    return P <= exports.unstable_now();
  };

  var T = new MessageChannel(),
      U = T.port2;

  T.port1.onmessage = function () {
    L = !1;
    var a = K,
        b = M;
    K = null;
    M = -1;
    var d = exports.unstable_now(),
        e = !1;
    if (0 >= P - d) if (-1 !== b && b <= d) e = !0;else {
      N || (N = !0, E(V));
      K = a;
      M = b;
      return;
    }

    if (null !== a) {
      O = !0;

      try {
        a(e);
      } finally {
        O = !1;
      }
    }
  };

  var V = function V(a) {
    if (null !== K) {
      E(V);
      var b = a - P + S;
      b < S && R < S ? (8 > b && (b = 8), S = b < R ? R : b) : R = b;
      P = a + S;
      L || (L = !0, U.postMessage(void 0));
    } else N = !1;
  };

  _r = function _r(a, b) {
    K = a;
    M = b;
    O || 0 > b ? U.postMessage(void 0) : N || (N = !0, E(V));
  };

  q = function q() {
    K = null;
    L = !1;
    M = -1;
  };
}

exports.unstable_ImmediatePriority = 1;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_NormalPriority = 3;
exports.unstable_IdlePriority = 5;
exports.unstable_LowPriority = 4;

exports.unstable_runWithPriority = function (a, b) {
  switch (a) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      break;

    default:
      a = 3;
  }

  var d = h,
      e = k;
  h = a;
  k = exports.unstable_now();

  try {
    return b();
  } finally {
    h = d, k = e, v();
  }
};

exports.unstable_scheduleCallback = function (a, b) {
  var d = -1 !== k ? k : exports.unstable_now();
  if ("object" === typeof b && null !== b && "number" === typeof b.timeout) b = d + b.timeout;else switch (h) {
    case 1:
      b = d + -1;
      break;

    case 2:
      b = d + 250;
      break;

    case 5:
      b = d + 1073741823;
      break;

    case 4:
      b = d + 1E4;
      break;

    default:
      b = d + 5E3;
  }
  a = {
    callback: a,
    priorityLevel: h,
    expirationTime: b,
    next: null,
    previous: null
  };
  if (null === c) c = a.next = a.previous = a, p();else {
    d = null;
    var e = c;

    do {
      if (e.expirationTime > b) {
        d = e;
        break;
      }

      e = e.next;
    } while (e !== c);

    null === d ? d = c : d === c && (c = a, p());
    b = d.previous;
    b.next = d.previous = a;
    a.next = d;
    a.previous = b;
  }
  return a;
};

exports.unstable_cancelCallback = function (a) {
  var b = a.next;

  if (null !== b) {
    if (b === a) c = null;else {
      a === c && (c = b);
      var d = a.previous;
      d.next = b;
      b.previous = d;
    }
    a.next = a.previous = null;
  }
};

exports.unstable_wrapCallback = function (a) {
  var b = h;
  return function () {
    var d = h,
        e = k;
    h = b;
    k = exports.unstable_now();

    try {
      return a.apply(this, arguments);
    } finally {
      h = d, k = e, v();
    }
  };
};

exports.unstable_getCurrentPriorityLevel = function () {
  return h;
};

exports.unstable_shouldYield = function () {
  return !f && (null !== c && c.expirationTime < l || w());
};

exports.unstable_continueExecution = function () {
  null !== c && p();
};

exports.unstable_pauseExecution = function () {};

exports.unstable_getFirstCallbackNode = function () {
  return c;
};